import React, { useState, useEffect } from "react";
import "./App.css";

const Medic_interval_palier2 = ({
  choix_medicaments = [],
  donnees_medicaments = {},
  init_duree = 7,
  setrendu = () => {}
}) => {
  const [cp_gellule, setcp_gellule] = useState(true);
  const [medicament, setMedicament] = useState(choix_medicaments[0]);
  const [posologie, setPosologie] = useState("");
  const [duree, setDuree] = useState(init_duree);
  const [dureeLibre, setDureeLibre] = useState("");
  const [texteLibre, setTexteLibre] = useState("");
  const [texteModifieManuellement, setTexteModifieManuellement] = useState(false);

  // Récupère les données du médicament sélectionné
  const dataMed = donnees_medicaments[medicament] || {
    posologies_cp: [],
    posologies_gel: [],
    texte_modele_cp: {},
    texte_modele_gel: {}
  };

  // Renvoie le texte modèle par défaut
  const makeDefaultText = (p) => {
    if (!p) return "";
    const modele = cp_gellule ? dataMed.texte_modele_cp : dataMed.texte_modele_gel;

    if (modele && modele[p]) {
      return modele[p]
        .replace(/\${nom_medicament}/g, medicament)
        .replace(/\${p}/g, p);
    }

    return `${medicament} ${p} : Posologie à adapter selon la tolérance.`;
  };

  // Met à jour la posologie quand on change de médicament ou présentation
  useEffect(() => {
    const firstPoso = cp_gellule
      ? (dataMed.posologies_cp[0] ?? "")
      : (dataMed.posologies_gel[0] ?? "");

    setPosologie(firstPoso);
    setTexteModifieManuellement(false);
  }, [medicament, cp_gellule]);

  // Met à jour le texte libre quand la posologie change
  useEffect(() => {
    if (!texteModifieManuellement) {
      setTexteLibre(makeDefaultText(posologie));
    }
  }, [posologie, cp_gellule, medicament]);

  // Remonte les infos dans le parent
  useEffect(() => {
    setrendu({
      nom: medicament,
      cp_gellule,
      posologie,
      duree: duree === 0 ? Number(dureeLibre || 0) : duree,
      texte: texteLibre
    });
  }, [medicament, cp_gellule, posologie, duree, dureeLibre, texteLibre]);

  const handleChangeDureeStd = (e) => {
    const v = Number(e.target.value);
    setDuree(v);
    if (v !== 0) setDureeLibre("");
  };

  // Détermine la liste des posologies affichées
  const posologiesDisponibles = cp_gellule
    ? dataMed.posologies_cp
    : dataMed.posologies_gel;

  return (
    <div className="med_a_inter">
      {/* Présentation */}
      <div className="med_gle_cp">
        <div className="text_poso">Présentation :</div>
        <div className="btn_cp">
          <button
            className={cp_gellule ? "btn btn-dark btn-sm" : "btn btn-outline-dark btn-sm"}
            onClick={() => setcp_gellule(true)}
            style={{ fontSize: "80%" }}
          >
            comprimé
          </button>
        </div>
        <div>
          <button
            className={!cp_gellule ? "btn btn-dark btn-sm" : "btn btn-outline-dark btn-sm"}
            onClick={() => setcp_gellule(false)}
            style={{ fontSize: "80%" }}
          >
            gélule
          </button>
        </div>
      </div>

      {/* Médicaments */}
      <div className="med_gle_cp" style={{ marginTop: "10px" }}>
        <div className="text_poso">Médicament :</div>
        <div className="btn_cp">
          {choix_medicaments.map((med) => (
            <button
              key={med}
              className={
                medicament === med
                  ? "btn btn-dark btn-sm"
                  : "btn btn-outline-dark btn-sm"
              }
              onClick={() => setMedicament(med)}
              style={{ fontSize: "80%", marginRight: "5px" }}
            >
              {med}
            </button>
          ))}
        </div>
      </div>

      {/* Posologie */}
      <div className="med_a_2">
        <div className="text_poso">Posologie :</div>
        <select
          className="form-select form-select-sm"
          value={posologie}
          onChange={(e) => {
            setPosologie(e.target.value);
            setTexteModifieManuellement(false);
          }}
          style={{ maxWidth: 200 }}
        >
          {posologiesDisponibles.map((p) => (
            <option key={p} value={p}>
              {p}
            </option>
          ))}
        </select>
      </div>

      {/* Texte libre */}
      <div className="med_a_2">
        <div className="text_poso">Texte modifiable :</div>
        <textarea
          className="form-control"
          rows={3}
          value={texteLibre}
          onChange={(e) => {
            setTexteLibre(e.target.value);
            setTexteModifieManuellement(true);
          }}
          placeholder="Le texte se génère automatiquement selon la posologie, puis vous pouvez l'adapter."
          style={{ width: "100%", fontSize: "90%" }}
        />
      </div>

      {/* Durée */}
      <div className="duree">
        Durée de prescription :{" "}
        {duree === 7 || duree === 14 || duree === 21 || duree === 28 || duree === 30 || duree === 60 || duree === 90 ? (
          <select
            id="dropdown"
            value={duree}
            onChange={handleChangeDureeStd}
            style={{ width: "60px" }}
          >
            <option value={7}>7</option>
            <option value={14}>14</option>
            <option value={21}>21</option>
            <option value={28}>28</option>
            <option value={30}>30</option>
            <option value={60}>60</option>
            <option value={90}>90</option>
            <option value={0}>autre</option>
          </select>
        ) : (
          <input
            type="text"
            value={dureeLibre}
            onChange={(e) => setDureeLibre(e.target.value)}
            style={{ width: "50px" }}
          />
        )}{" "}
        jours
      </div>
    </div>
  );
};

export default Medic_interval_palier2;
